module.exports = __webpack_public_path__ + "static/media/doneDarkMode.b2f7fcff.svg";